import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "p-2 flex flex-col rounded bg-sky-50"
};
const _hoisted_2 = {
  class: "flex-center"
};
const _hoisted_3 = {
  class: "flex-1"
};
const _hoisted_4 = {
  class: "mb-1"
};
const _hoisted_5 = {
  class: "flex-1 flex items-center justify-end"
};
const _hoisted_6 = {
  key: 0,
  class: "flex items-center border-t mt-2 pt-2"
};
const _hoisted_7 = {
  key: 0
};
import { app } from "@/di";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import StadiumFoundationExpander from "@/modules/stadium/services/StadiumFoundationExpander";
import { EventEmitter } from "@/modules/base/events";
import Effects from "@/modules/club-grounds/components/slot-types/Effects.vue";
import { EffectTypeEnum } from "@/modules/club-grounds/enums";
import FoundationSeatLimitProvider from "@/modules/stadium/services/FoundationSeatLimitProvider";
import AfterCurrencyChangeEvent from "@/modules/action-points/ events/AfterCurrencyChangeEvent";
export default /*#__PURE__*/_defineComponent({
  __name: 'Foundation',
  props: {
    stadium: null
  },
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const configRepository = app.get(ConfigRepository);
    const foundationDuration = ref();
    const foundationCost = ref();
    const maxLevel = ref();
    const seatLimitProvider = app.get(FoundationSeatLimitProvider);
    const effects = ref([{
      type: EffectTypeEnum.SPECTATORS,
      value: 3,
      percent: true,
      label: translator.t('increase_spectators_popularity')
    }, {
      value: seatLimitProvider.getDiff(props.stadium.foundationLevel + 1),
      label: translator.t('increased_terrace_seat_limits')
    }, {
      value: 5,
      percent: true,
      label: translator.t('increase_cost_for_terrace_seats'),
      negative: true
    }]);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(() => useInitial(async () => {
      foundationDuration.value = configRepository.get('stadium.durations.foundation')(props.stadium);
      foundationCost.value = configRepository.get('stadium.costs.foundation')(props.stadium);
      maxLevel.value = configRepository.get('stadium.foundation.maxLevel');
    })), __temp = await __temp, __restore(), __temp);
    onUnmounted(app.get(EventEmitter).onOff([AfterCurrencyChangeEvent], refresh));
    const confirmation = ref(null);
    const message = useMessage();
    const onClickDevelop = () => {
      confirmation.value.confirm().then(async () => {
        await app.get(StadiumFoundationExpander).queue(props.stadium);
        await refresh();
        message.success(translator.t('done'));
      });
    };
    return (_ctx, _cache) => {
      const _component_NRate = _resolveComponent("NRate");
      const _component_NButton = _resolveComponent("NButton");
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_NRate, {
        readonly: "",
        "default-value": __props.stadium.foundationLevel
      }, null, 8, ["default-value"])]), _createElementVNode("div", null, _toDisplayString(_ctx.$t('seats_x', {
        seats: __props.stadium.seats
      })), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createVNode(_component_NButton, {
        type: "primary",
        disabled: !!__props.stadium.foundationFinishedAt || __props.stadium.foundationLevel >= maxLevel.value,
        onClick: onClickDevelop
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('develop')), 1)]),
        _: 1
      }, 8, ["disabled"]), _createVNode(RichDialog, {
        ref_key: "confirmation",
        ref: confirmation,
        days: foundationDuration.value,
        price: foundationCost.value,
        "gate-type": _ctx.GateTypeEnum.BALANCE,
        "gate-value": foundationCost.value
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('are_you_sure_want_to_develop_the_foundation?')), 1)]),
        default: _withCtx(() => [_createVNode(Effects, {
          effects: effects.value
        }, null, 8, ["effects"])]),
        _: 1
      }, 8, ["days", "price", "gate-type", "gate-value"])])])]), __props.stadium.foundationFinishedAt ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_Icon, {
        icon: _ctx.IconEnum.ConstructionOutlined,
        class: "mr-4",
        size: "2rem"
      }, null, 8, ["icon"]), _createElementVNode("div", null, [_createTextVNode(_toDisplayString(_ctx.$t('development_ongoing_until_x', {
        date: _ctx.$date(__props.stadium.foundationFinishedAt)
      })) + " ", 1), __props.stadium.seats !== __props.stadium.seatsWhenFinished ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('seats_when_finished_x', {
        seats: __props.stadium.seatsWhenFinished
      })), 1)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
    };
  }
});